import { render, staticRenderFns } from "./question-edit.vue?vue&type=template&id=e02f8e5e&scoped=true"
import script from "./question-edit.vue?vue&type=script&lang=ts"
export * from "./question-edit.vue?vue&type=script&lang=ts"
import style0 from "./question-edit.vue?vue&type=style&index=0&id=e02f8e5e&prod&lang=scss"
import style1 from "./question-edit.vue?vue&type=style&index=1&id=e02f8e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02f8e5e",
  null
  
)

export default component.exports